import { CollectionModuleVO, CurrentAccountVO } from '@/types/collection-module'
import { getCollectionModules, getCurrentAccount } from '@/services/collection-module'
import { atom, useRecoilState } from 'recoil'
import { useCallback, useEffect, useMemo } from 'react'
import { MODULE_STATUS_TYPE, SHEET_MODULES } from '@/constants/collection-module'
import { isEmpty } from 'lodash-es'

const noLoginPage = ['#/fast-login']

export const moduleStatusAtom = atom<CollectionModuleVO[]>({
  key: 'module-status-atom',
  default: [],
})

export const currentAccountAtom = atom<CurrentAccountVO>({
  key: 'current-account-atom',
  default: undefined,
})
export const currentFormIdAtom = atom<number | undefined>({
  key: 'current-formid-atom',
  default: undefined,
})

export function useCurrentAccount(hash: string) {
  const [, setCurrentAccount] = useRecoilState(currentAccountAtom)

  const getData = useCallback(async () => {
    if (hash && noLoginPage.includes(hash)) {
      setCurrentAccount({} as CurrentAccountVO)
      return
    }
    try {
      const { code, message: msg, result } = await getCurrentAccount()
      if (code === '0') {
        setCurrentAccount(result)
      } else {
        console.warn(msg)
      }
    } catch (e) {
      console.warn(e)
      setCurrentAccount({} as CurrentAccountVO)
    }
  }, [setCurrentAccount, hash])
  useEffect(() => {
    getData()
  }, [getData])
}

export function useFormModules() {
  const [formModules, setFormModules] = useRecoilState(moduleStatusAtom)

  const getFormModules = useCallback(async (id: number | string) => {
    try {
      const { code, message: msg, result } = await getCollectionModules(id)
      if (code === '0') {
        setFormModules(result)
      } else {
        console.warn(msg)
        setFormModules([])
      }
    } catch (e) {
      console.warn(e)
      setFormModules([])
    }
  }, [setFormModules])

  const formModulesObj = useMemo(() => {
    const moduleInfo: Record<string, CollectionModuleVO> = {}
    formModules.forEach((module) => { moduleInfo[module.moduleIdentity] = module })

    return moduleInfo
  }, [formModules])

  const formModuleIsSubmit = useMemo(() => {
    const atlasTenantSubmit = [MODULE_STATUS_TYPE.TO_BE_REVIEWED, MODULE_STATUS_TYPE.DONE].includes(formModulesObj[SHEET_MODULES.ATLASTENANT]?.moduleStatus)
    const lessonSelectSubmit = [MODULE_STATUS_TYPE.TO_BE_REVIEWED, MODULE_STATUS_TYPE.DONE].includes(formModulesObj[SHEET_MODULES.LECTIOLESSONSELECT]?.moduleStatus)
    const atlasTeacherSubmit = [MODULE_STATUS_TYPE.TO_BE_REVIEWED, MODULE_STATUS_TYPE.DONE].includes(formModulesObj[SHEET_MODULES.ATLASTEACHER]?.moduleStatus)
    const atlasClassSubmit = [MODULE_STATUS_TYPE.TO_BE_REVIEWED, MODULE_STATUS_TYPE.DONE].includes(formModulesObj[SHEET_MODULES.ATLASMCLASS]?.moduleStatus)
    const scheduleSubmit = [MODULE_STATUS_TYPE.TO_BE_REVIEWED, MODULE_STATUS_TYPE.DONE].includes(formModulesObj[SHEET_MODULES.LECTIOSCHEDULE]?.moduleStatus)
    const atlasStudentSubmit = [MODULE_STATUS_TYPE.TO_BE_REVIEWED, MODULE_STATUS_TYPE.DONE].includes(formModulesObj[SHEET_MODULES.ATLASSTUDENT]?.moduleStatus)
    const atlasCourseSubmit = [MODULE_STATUS_TYPE.TO_BE_REVIEWED, MODULE_STATUS_TYPE.DONE].includes(formModulesObj[SHEET_MODULES.ATLASCOURSE]?.moduleStatus)

    return { atlasTenantSubmit, lessonSelectSubmit, atlasTeacherSubmit, atlasClassSubmit, scheduleSubmit, atlasStudentSubmit, atlasCourseSubmit }
  }, [formModulesObj])

  return {
    formModules,
    getFormModules,
    formModulesObj,
    formModuleIsSubmit,
  }
}
